import { render, staticRenderFns } from "./tabPreference.vue?vue&type=template&id=565ff5b8&"
import script from "./tabPreference.vue?vue&type=script&lang=js&"
export * from "./tabPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports